export default __webpack_public_path__ + "static/media/2-banner.a9362072.png";